import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function PerfectHome() {
  const { t } = useTranslation();
  UseScrollAnimation();
  return (
    <section className="relative py-[40px]">
      <div className="f-col gap-res-20 container flex items-center justify-between">
        <div className="just-center it-center text-center-res w-100 w-[48%] flex flex-col justify-between gap-[15px]">
          <div className="flex flex-col gap-[15px]">
            <div className="js-scroll fade-top text-[30px] leading-[1.1] font-bold capitalize">
              {t(
                "Professional Property Management for Your Dubai Investment"
              )}
            </div>
            <p className="js-scroll fade-top leading-[1.1]">{t("PerfectText")}</p>
          </div>
          <Link to={"/properties"} className="js-scroll fade-top flex items-center gap-[7px] bg-[#0B2C3D] w-fit capitalize py-[8px] px-[30px] rounded-[4px] font-bold text-white">
            {t("show More")}
            <img
              src={require("../../assets/icons/arrow-button.svg").default}
              alt=""
              className="w-[15px] h-[15px]"
            />
          </Link>
        </div>
        <div className="w-100 w-[48%] h-[500px]">
          <img
            className="js-scroll fade-btm d-none w-full h-full"
            src="https://strapi-darglobaldev.s3.me-central-1.amazonaws.com/public_56bc7a6583.avif"
            alt=""
          />
        </div>
      </div>
    </section>
  );
}
